module.exports = __webpack_public_path__ + "img/3.78a64a2a.png";